module.exports = __webpack_public_path__ + "media/images/logos/plinth-2d3b968711126e9abbca09db73c2f16d.svg";